/**
 * Money as a string, for places that need text rather than <MoneyDisplay>
 * (accessibility labels, sentences). Whole dollars when the amount is
 * whole, cents when it is not, thousands separated, sign in front:
 * 2000 → "$20", 123456 → "$1,234.56", -500 → "-$5". Never floors: a spoken
 * or written balance must match the drawn one to the cent.
 */
export function formatMoney(cents: number): string {
  const sign = cents < 0 ? '-' : '';
  const abs = Math.abs(cents);
  const dollars = Math.floor(abs / 100);
  const rest = abs % 100;
  const whole = dollars.toLocaleString('en-US');
  return rest === 0
    ? `${sign}$${whole}`
    : `${sign}$${whole}.${String(rest).padStart(2, '0')}`;
}
